namespace GeniuzPOS.Purchase {
    export class PoInvoiceReceiveAppColumns {
        static columnsKey = 'Purchase.PoInvoiceReceiveApp';
    }
}
